// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n\tbackground-color: #151518;\n\tcolor: white;\n\tfont-family: -apple-system, Roboto, sans-serif;\n\tmargin: 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
